import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({ // the following are global states need to track throughout the app
  strict: true, // no modification on the following states is allowed
  plugins: [
    createPersistedState()
  ],
  state: {
    token: null,
    isUserLoggedIn: false,
    queryingState: false,
    account: null,
    version: ''
  },
  mutations: {
    setToken (state, token) {
      state.token = token
      if (token) {
        state.isUserLoggedIn = true
      } else {
        state.isUserLoggedIn = false
      }
    },
    setAccount (state, account) {
      state.account = account
    },
    setQueryingState (state, queryingState) {
      state.queryingState = queryingState
    },
    setVersion (state, version) {
      state.version = version
    }
  },
  actions: { // the definitions below will call corresponding mutation methods defined above
    setToken ({ commit }, token) {
      commit('setToken', token)
    },
    setQueryingState ({ commit }, token) {
      commit('setQueryingState', token)
    },
    setAccount ({ commit }, token) {
      commit('setAccount', token)
    },
    setVersion ({ commit }, version) {
      commit('setVersion', version)
    }
  }
})
